import EnglishFlag from '@public/assets/images/en_us_flag.png';
import DutchFlag from '@public/assets/images/nl_flag.png';
export const LanguageFlags = {
    English: EnglishFlag,
    Dutch: DutchFlag
};
